var userAgent = navigator.userAgent;
var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
var isReset = true;

if (isiOS) {
    document.body.addEventListener('focusin', () => {
        // 软键盘弹出的事件处理
        isReset = false;
    })

    document.body.addEventListener('focusout', () => {
        // 软键盘收起的事件处理
        isReset = true;
        setTimeout(() => {
            // 当焦点在弹出层的输入框之间切换时先不归位
            if (isReset) {
                window.scroll(0, 0); // 失焦后强制让页面归位
            }
        }, 300);
    })
}
